
// Predefined sound effects configuration
import { SoundManager } from './sound-manager';

// Sound effect definitions
export const SOUND_EFFECTS = {
  FIREWORKS: {
    id: 'fireworks',
    url: "https://etrspsphgbkapczqxboy.supabase.co/storage/v1/object/public/sounds//11L-fireworks_pop_and_sp-1743240602715.mp3",
    volume: 1.0
  },
  BUTTON_CLICK: {
    id: 'buttonClick',
    url: "https://etrspsphgbkapczqxboy.supabase.co/storage/v1/object/public/sounds//11L-satisfying_asmr_butt-1743297754651.mp3",
    volume: 1.0
  },
  BUTTON_DOWN: {
    id: 'buttonDown',
    url: "https://etrspsphgbkapczqxboy.supabase.co/storage/v1/object/public/sounds//11L-satisfying_asmr_button-down-1743297971414.flac",
    volume: 1.0
  },
  BUTTON_UP: {
    id: 'buttonUp',
    url: "https://etrspsphgbkapczqxboy.supabase.co/storage/v1/object/public/sounds//11L-satisfying_asmr_button-up-1743297971414.flac",
    volume: 1.0
  }
};

// Function to register all predefined sounds with a SoundManager instance
export function registerPredefinedSounds(soundManager: SoundManager): void {
  Object.values(SOUND_EFFECTS).forEach(effect => {
    soundManager.registerSound(effect.id, effect.url, effect.volume);
  });
}
